<div style="align-content:center;">
  <button class="btn border ms-4 mt-3" (click)="captureScreen()">Skapa pdf-fil</button>
  <button class="btn border ms-2 mt-3" (click)="continue()">Fortsätt</button>
</div>
<br><br>
<div #contentToConvert class="container">
  <div>
    <div class="header">
      Kontoinformation för: <b>{{memberdata?.givenName}} {{memberdata?.familyName}}</b> ({{memberdata?.memberId}})
    </div>
    <div class="medlemheader">
      <div class="row">
        <br><br>
        <div class="col-md-6 bold">Privata uppgifter</div>
        <div class="col-md-6 bold">Användaruppgifter</div>
        <br><br>
        <div class="col-md-2">Namn</div>
        <div class="col-md-4">{{memberdata?.givenName}} {{memberdata?.familyName}}</div>
        <div class="col-md-2">Användarnamn</div>
        <div class="col-md-4">{{memberdata?.memberId}}</div>
        <div class="col-md-2">Medlemsnummer</div>
        <div class="col-md-4">{{memberdata?.memberId}}</div>
        <div class="col-md-2">Lösenord</div>
        <div class="col-md-4">{{memberdata?.password}}</div>
        <div class="col-md-2">Primärinstitution</div>
        <div class="col-md-4">{{memberdata?.primaryInstitution}}</div>
      </div>
    </div>
    <br><br>
    Broder/Syster välkommen till ODD FELLOW och din loge.<br><br>
    Detta är dina uppgifter för att komma in i vårt medlemssystem.
    <br><br>
    Lycka till med ditt medlemskap !
  </div>
</div>